function buocLichSuKho() {
  return [
    {
      target: "body",
      placement: "center",
      title: "Bước 1 · Lịch sử kho",
      content:
        "Mỗi lần nhập/xuất kho được ghi vào đây (vì xuất kho xoá số liệu tạm trên Sọt để tái sử dụng). Dùng để đối soát hao hụt theo chu kỳ.",
    },
    {
      target: "#tour-lich-su-kho-bo-loc",
      title: "Bước 2 · Lọc theo ngày / người",
      content: "Chọn khoảng ngày và (nếu cần) người thực hiện để thu hẹp danh sách bên dưới.",
      placement: "bottom",
    },
    {
      target: "#tour-lich-su-kho-bang",
      title: "Bước 3 · Chi tiết từng lượt",
      content:
        "Mỗi dòng là một chu kỳ nhập/xuất của một Sọt. Bấm vào dòng để xem chi tiết, gồm hao hụt từ lúc thu mua đến lúc xuất kho.",
      placement: "top",
    },
  ];
}

export default buocLichSuKho;
